import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations/dist/vue';
import { Integrations } from '@sentry/tracing';
import LogRocket from './logrocket';

Sentry.init({
  enabled: process.env.NODE_ENV === 'production',
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [
    new Integrations.BrowserTracing(),
    new VueIntegration({
      Vue,
      attachProps: true,
      tracing: true,
      tracingOptions: {
        trackComponents: true,
      },
      logErrors: process.env.NODE_ENV !== 'production', // does not show errors in console for prod
    })],
  environment: process.env.NODE_ENV,
  release: process.env.VUE_APP_GIT_RELEASE,
});

Sentry.setTag('server_name', process.env.VUE_APP_SENTRY_SERVER_NAME);

LogRocket.getSessionURL((url) => {
  Sentry.configureScope((scope) => {
    scope.setExtra('logRocketURL', url);
  });
});

export default Sentry;
